var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_780_13403)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.7998,
    y: 2.80005,
    width: 60,
    height: 60,
    rx: 30,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.43 43.26H28.63C26.9597 43.2757 25.3454 42.6584 24.1117 41.5323C22.878 40.4062 22.1164 38.8548 21.98 37.19C21.745 33.4604 21.745 29.7196 21.98 25.99C22.1106 24.4397 22.793 22.9877 23.9032 21.8978C25.0133 20.8078 26.4776 20.1522 28.03 20.05C33.1947 19.72 38.3752 19.72 43.54 20.05C45.0934 20.1519 46.559 20.8072 47.6708 21.897C48.7826 22.9867 49.467 24.4389 49.6 25.99C49.87 29.7184 49.87 33.4615 49.6 37.19C49.4635 38.8565 48.7004 40.4094 47.4646 41.5357C46.2288 42.6621 44.612 43.2782 42.94 43.26H39.28L32.43 47.8V43.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.37 38.48H43.04C43.553 38.4917 44.0523 38.3134 44.4418 37.9793C44.8313 37.6451 45.0835 37.1788 45.15 36.67C45.35 33.2129 45.35 29.7471 45.15 26.29C45.1108 25.8245 44.9015 25.3897 44.5621 25.0687C44.2227 24.7478 43.7769 24.5631 43.31 24.55C38.3155 24.2182 33.3045 24.2182 28.31 24.55C27.85 24.5726 27.414 24.7616 27.0829 25.0816C26.7518 25.4017 26.5482 25.8311 26.51 26.29C26.25 29.7444 26.23 33.2128 26.45 36.67C26.4983 37.1846 26.744 37.6605 27.1355 37.9979C27.527 38.3353 28.0339 38.5081 28.55 38.48H32.36V43.3L39.37 38.48Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_780_13403",
    x: -0.000195503,
    y: 0.0000486374,
    width: 71.6,
    height: 71.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_780_13403"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_780_13403"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_780_13403"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.362176
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.470829
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.125 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_780_13403",
    result: "effect2_dropShadow_780_13403"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_780_13403",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChat);
export default __webpack_public_path__ + "static/media/live-chat.b81c73e66d90f7f25b244fa2e410f70f.svg";
export { ForwardRef as ReactComponent };